import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from "react-router-dom";
import AuthLocked from "../../components/auth/AuthLocked";
import { authByDs, backToRequest, codeRequest, codeValidate, recovery } from "../../actions/auth";
import { authPageSettings } from "../../actions/catalog";
import { getScreenSize } from "../../tools/tools";

import Auth from "../../components/auth/Auth";
import Recovery from "../../components/auth/Recovery";
import PropTypes, { exact } from "prop-types";
import RegistrationContainer from "./RegistrationContainer";
import ConfirmationContainer from "./ConfirmationContainer";
import LoginLayout from '../../components/common/layout/LoginLayout';
import { regByDs, regReset } from '../../actions/reg';
import { checkSignatureAction, getCerfInfoAction, getUserCertificatesAction, signCertificateAction } from '../../actions/diadocAction';

class AuthContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    static contextTypes = {
        currentLanguage: PropTypes.object,
        translate: PropTypes.func
    }

    componentDidMount = () => {
        this.setState({ screenSize: getScreenSize() });
        window.addEventListener('resize', this.onResize);
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    };

    onResize = () => {
        this.setState({ screenSize: getScreenSize() });
    };

    componentWillMount() {
        if (!this.props.pageSettings) {
            this.props.authPageSettings();
        }
    }

    componentWillReceiveProps(nextProps) {

        if (this.props.splashImages != nextProps.splashImages) {
            if (nextProps.splashImages) {
                nextProps.splashImages.map((image) => {
                    var img = new Image();
                    img.src = image;
                })
            }
        }
    }

    render() {

        let isRegPage = false;
        let isRecovery = false;
        let isLoginPage = false;
        let isConfirmation = false;
        if (window.location.pathname.includes('/registration')) isRegPage = true;
        if (window.location.pathname.includes('/recovery')) isRecovery = true;
        if (window.location.pathname.includes('/login')) isLoginPage = true;
        if (window.location.pathname.includes('/confirmation')) isConfirmation = true;
        const { location } = this.props;
        const switcher = (location && location.state && location.state.switcher) !== undefined
            ? location.state.switcher
            : false;
        let {
            authState,
            onCodeRequest,
            toCodeRequest,
            onCodeValidate,
            recovery,
            pageSettings,
            onChangeStep,
            regByDsAct,
            authByDsAct,
        } = this.props;
        
        if (authState.checkingLocked) {
            return <div className="auth login_page" />;
        }

        if (authState.blocked) {
            return <LoginLayout
                {...this.props}
                step={2}
                isRegPage={isRegPage}
                isRecovery={isRecovery}
                isLoginPage={isLoginPage}
                isConfirmation={isConfirmation}
                authByDs={authState.authByDs}
            >
                <div className="auth__block">
                    <AuthLocked
                        pageSettings={pageSettings}
                        type={authState.blockedCode}
                        regByDsAct={this.props.regByDsAct}
                        authByDsAct={this.props.authByDsAct} />
                </div>

            </LoginLayout>

        }
        return (
            <LoginLayout
                {...this.props}
                step={authState.step}
                isRegPage={isRegPage}
                isRecovery={isRecovery}
                isLoginPage={isLoginPage}
                isConfirmation={isConfirmation}
                authByDs={authState.authByDs}
            >
                <div className={authState.step == 1 && !isRegPage && !isRecovery && !isConfirmation && !authState.authByDs ? "auth__page" : 'auth__page_second_steps'}>

                    {pageSettings ? <div>
                        <div className="auth__block">
                            <Switch>
                                <Route path="/login" render={
                                    () => {
                                        return <Auth {...authState}
                                            switcher={switcher}
                                            onCodeRequest={onCodeRequest}
                                            toCodeRequest={toCodeRequest}
                                            onCodeValidate={onCodeValidate}
                                            pageSettings={pageSettings}
                                            regStepChange={onChangeStep}
                                            regByDsAct={regByDsAct}
                                            regReset={this.props.regReset}
                                            authByDsAct={authByDsAct}
                                            getUserCertificatesAction={this.props.getUserCertificatesAction}
                                            getCerfInfoAction={this.props.getCerfInfoAction}
                                            diadocState={this.props.diadocState}
                                            signCertificateAction={this.props.signCertificateAction}
                                            checkSignature={this.props.checkSignature}
                                            changeConfStep={this.props.changeConfStep}
                                            isRegPage={isRegPage}
                                        />
                                    }
                                } />

                                <Route path="/registration" render={
                                    () => { return <RegistrationContainer isRegPage={isRegPage} /> }
                                } />

                                <Route path="/confirmation" render={
                                    () => { return <ConfirmationContainer /> }
                                } />
                                <Route path="/recovery" render={
                                    () => {
                                        return <Recovery {...authState}
                                            recovery={recovery}
                                            toCodeRequest={toCodeRequest}
                                            diadocState={this.props.diadocState}
                                            getUserCertificatesAction={this.props.getUserCertificatesAction}
                                            getCerfInfoAction={this.props.getCerfInfoAction}
                                            signCertificateAction={this.props.signCertificateAction}
                                            checkSignature={this.props.checkSignature}
                                            regByDsAct={regByDsAct}
                                            authByDsAct={authByDsAct}
                                        />
                                    }
                                } />
                                <Route path="*" render={() => { return <Redirect to={"/login"} /> }} />
                            </Switch>

                        </div>
                    </div>
                        : null}
                </div>
            </LoginLayout>
        )
    }
}

export default connect(
    state => ({
        splashImages: state.catalog && state.catalog.splashImages,
        authState: state.auth,
        pageSettings: state.catalog && state.catalog.authPageSettings,
        multilingual: state.multilingual,
        regState: state.reg,
        diadocState: state.diadocReducer
    }),
    (dispatch) => {
        return {
            onCodeRequest: (phone, password) => dispatch(codeRequest(phone, password)),
            toCodeRequest: () => dispatch(backToRequest()),
            onCodeValidate: (phone, code) => dispatch(codeValidate(phone, code)),
            authPageSettings: () => dispatch(authPageSettings()),
            recovery: (action, data) => dispatch(recovery(action, data)),
            onChangeStep: (step) => dispatch({ type: 'REG_CHANGE_STEP', step }),
            regByDsAct: (value) => dispatch(regByDs(value)),
            authByDsAct: (value) => dispatch(authByDs(value)),
            getUserCertificatesAction: () => dispatch(getUserCertificatesAction()),
            getCerfInfoAction: (thumbprint) => dispatch(getCerfInfoAction(thumbprint)),
            signCertificateAction: (thumbprint, contentPdf) => dispatch(signCertificateAction(thumbprint, contentPdf)),
            checkSignature: (data) => dispatch(checkSignatureAction(data)),
            changeConfStep: (step) => dispatch({ type: 'CONFIRMATION_STEP_CHANGE', payload: step }),
            regReset: () => dispatch(regReset()),
        }
    }
)(AuthContainer);